import { TableFilters, type TableFilterField } from '@shared/ui';
import { candidateFiltersConfig, initialValues } from '../constants';
import { useGetCandidateStatuses } from '@entities/candidates';
import { useEffect, useState } from 'react';
import type { CandidateFiltersForm, CandidateFiltersQuery } from '../types';

type CandidateListFiltersProps = {
  pageSize?: number;
  setFilter: (filter: CandidateFiltersQuery) => void;
};

export const CandidateListFilters = ({
  setFilter,
  pageSize,
}: CandidateListFiltersProps) => {
  const [config, setConfig] = useState<TableFilterField[]>(
    candidateFiltersConfig
  );
  const { data, isLoading } = useGetCandidateStatuses();

  useEffect(() => {
    if (data && !isLoading) {
      const statusOptions = [
        { value: '', label: 'Все' },
        ...data.map(status => ({
          value: status.name,
          label: status.displayName,
        })),
      ];

      setConfig(prev =>
        prev.map(filter =>
          filter.name === 'status'
            ? { ...filter, options: statusOptions }
            : filter
        )
      );
    }
  }, [data, isLoading]);

  return (
    <TableFilters<CandidateFiltersForm>
      config={config}
      initialValues={initialValues}
      setFilter={setFilter}
      pageSize={pageSize}
    />
  );
};
